import { Stack, Typography } from "@mui/material";
import { Link, Outlet, useLocation } from "react-router-dom";
import { startCase } from "lodash";
import { BreadcrumbsContainer, BreadcrumbsContextProvider } from "@components/custom-components/breadcrumbs/BreadcrumbsContext";
import RootProtectedRoute from "@components/routing/RootProtectedRoute";
import RootLayout from "@components/layouts/root-layout/RootLayout";

const SuperAdminLayout = () => {
  const { pathname } = useLocation();
  const locations = pathname?.split("/");

  return (
    <RootProtectedRoute>
      <RootLayout>
        <BreadcrumbsContextProvider>
          <Stack p={3}>
            <BreadcrumbsContainer>
              {locations?.slice(1).map((l, index) => (
                <Link key={index} color="inherit" to={`/${locations?.slice(1, index + 2).join("/")}`}>
                  <Typography variant="breadcrumbs">
                    {startCase(l === "dashboard" ? `Dashboard` : l)}
                  </Typography>
                </Link>
              ))}
            </BreadcrumbsContainer>
            <Outlet />
          </Stack>
        </BreadcrumbsContextProvider>
      </RootLayout>
    </RootProtectedRoute>
  );
};

export default SuperAdminLayout;
